import React from 'react';
import { capitalize, Stack, Typography } from '@mui/material';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

interface Props {
  departmentsWithStages: {
    flowId: string;
    department: string;
    departmentName: string;
    currentStageId: string;
    currentStageName: string;
  }[];
}

export const DepartmentsCell = ({ departmentsWithStages }: Props) => (
  <RenderWithCondition
    condition={Boolean(departmentsWithStages.length)}
    fallBack={<Typography align="center">-</Typography>}
  >
    <Stack>
      {departmentsWithStages.map(({ flowId, department, currentStageName }) => (
        <Typography variant="body2" key={flowId}>
          {capitalize(department)}: {currentStageName || 'N/A'}
        </Typography>
      ))}
    </Stack>
  </RenderWithCondition>
);
